export default __webpack_public_path__ + "static/media/StarWars.756ebdb3.png";